import { ChartType } from "../report/entities/reportEntity";
import * as charts from "../report/charts";

export const MONITOR_PROJECT_ID = 208978076237824;

export const VALID_PATENT_CONDITION = {
  name: "legalStatus",
  operator: "NOT_IN",
  value1: "全部无效,失效,未确认,避重放弃,主动放弃,终止,终止|复审请求,视为放弃,视为放弃|转让,全部无效|转让|许可,全部无效|许可,全部无效|转让,终止|转让,全部无效|质押,全部无效|复审请求,主动放弃|复审请求,视为放弃|许可,终止|转让|许可,全部无效|转让|复审请求,主动放弃|转让|复审请求,驳回,驳回|转让,驳回|转让|复审请求,驳回|转让|复审请求,驳回|复审请求,驳回|许可|复审请求,驳回|许可,届满|质押|许可"
};

export const MONITOR_REPOPRTS: any = {
  basicModel: {
    label: "专利概况",
    chart: charts.lineAndBar2D,
    definition: {
      rowDims: [{ name: "legalStatus", label: "法律状态", limit: 20, needTotal: true }],
      colDims: [{ name: "patentType", label: "专利类型", needTotal: true }],
      measures: [{ name: "count", label: "申请量", minValue: 0, sortBy: "DESC" }],
      condition: {
        items: [{
          name: "legalStatus",
          operator: "NOT_NULL"
        }, {
          name: "patentType",
          operator: "NOT_NULL"
        }]
      }
    },
    chartOption: {
      chartType: ChartType.LINE,
      title: "专利概况统计图",
      subTitle: "",
      hideTitle: false,
      xaxisTitle: "",
      yaxisTitle: "",
      hideAxisTitle: true,
      hideLabel: false,
      hideLegend: false,
      hideToolbox: true
    }
  },
  validPatentModel: {
    label: "有效专利监控",
    chart: charts.lineAndBar2D,
    definition: {
      rowDims: [{ name: "appDate", label: "申请月", dateUnit: "MONTH", limit: 10, needTotal: true, sortBy: "DESC" }],
      colDims: [{ name: "patentType", label: "专利类型", needTotal: true }],
      measures: [{ name: "count", label: "申请量", minValue: 0 }],
      condition: {
        items: [{
          name: "patentType",
          operator: "NOT_NULL"
        }, {
          name: "appDate",
          operator: "NOT_NULL"
        }, VALID_PATENT_CONDITION]
      }
    },
    chartOption: {
      chartType: ChartType.LINE,
      title: "有效专利监控统计图",
      subTitle: "",
      hideTitle: false,
      xaxisTitle: "",
      yaxisTitle: "",
      hideAxisTitle: true,
      hideLabel: false,
      hideLegend: false,
      hideToolbox: true
    }
  },
  applicantModel: {
    label: "申请人排行",
    definition: {
      rowDims: [{ name: "applicantNewName", label: "申请人", table: "patent_applicant", limit: 20, needTotal: true }],
      measures: [{ name: "count", label: "申请量", minValue: 0, sortBy: "DESC" }],
      condition: {
        items: [{
          name: "authDate",
          operator: "NOT_NULL"
        }]
      }
    }
  },
  inventorModel: {
    label: "发明人排行",
    definition: {
      rowDims: [{ name: "inventorNewName", label: "发明人", table: "patent_inventor", limit: 20, needTotal: true }],
      measures: [{ name: "count", label: "申请量", minValue: 0, sortBy: "DESC" }],
      condition: {
        items: [{
          name: "authDate",
          operator: "NOT_NULL"
        }]
      }
    }
  }
};
